import React from 'react'
import Header from "../components/Header"
import Footer from "../components/Footer"
import { motion } from "framer-motion"
import Leading from "../media/leading.avif"
import Img1 from "../media/img1.avif";
import Img2 from "../media/img2.avif";
import Img3 from "../media/img3.avif";
import Img4 from "../media/img4.avif";
import Rewarding from "../media/Rewarding.avif"

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

export default function SEC(){
    return(
        <>
            <Header />
            <div className='w-full'>
                {/* Hero Section */}
                <motion.section
                    className="relative mt-16 md:mt-24 h-[70vh] bg-cover bg-center"
                    style={{ backgroundImage: `url(${Leading})` }}
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeInUp}
                    viewport={{ once: true }}
                >
                    <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                    <h1 className="text-white font-serif text-3xl md:text-5xl font-bold text-center">
                        Leading the Way in Sustainable and Ethical Fashion
                    </h1>
                    </div>
                </motion.section>
        
                {/* Intro Section */}
                <motion.section
                    className="max-w-7xl mx-auto px-6 py-16 text-center"
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeInUp}
                    viewport={{ once: true }}
                >
                    <h2 className="text-3xl font-serif md:text-4xl mb-6 text-slate-600">
                    We set the standard by embracing an ethical approach at every stage, from concept to completion.
                    </h2>
                </motion.section>

                <section className="py-20 bg-slate-100">
                    <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center gap-10">
                    <motion.div
                        className="md:w-full"
                        variants={fadeInUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                    >
                        <h2 className="text-3xl text-center text-black font-bold font-serif mb-4">
                            Our sustainable development goals
                        </h2>
                        <p className="text-gray-700 text-center leading-snug">
                            At Yking, sustainability is a core priority. We recognize that unsustainable business models or sourcing strategies will have long-term consequences, which is why we're taking action now—while it can still make a meaningful difference. Throughout our business, we are dedicated to exploring innovative and more impactful ways to operate sustainably, building a company that not only creates but also cares about its environmental footprint.
                            <br />
                            <br />
                            We are committed to maintaining a robust portfolio of industry-leading compliance certifications, reflecting our dedication to sustainable and environmentally responsible practices. Our certifications include RCS, GOTS, BCI, GRS, HIGG, OEKO-TEX, OCS, ISO, STeP, among others—demonstrating our continuous efforts to meet and exceed global standards.
                        </p>
                    </motion.div>
                    {/* <motion.div
                        className="md:w-1/2"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.7 }}
                        viewport={{ once: true }}
                    >
                        <img
                        src={Rewarding}
                        alt="Team Celebration"
                        className="rounded-full shadow-md"
                        />
                    </motion.div>     */}
                    </div>
                </section>

                <section className="py-20 bg-gray-50">
                    <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center gap-10">
                    <motion.div
                        className="md:w-1/2"
                        variants={fadeInUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                    >
                        <h2 className="text-3xl font-bold text-black font-serif mb-4">
                        Wherever we are in the world, the same principles drive everything we do.
                        </h2>
                    </motion.div>
                    <motion.div
                        className="md:w-1/2"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.7 }}
                        viewport={{ once: true }}
                    >
                        <img
                        src={Rewarding}
                        alt="Team Celebration"
                        className="rounded-xl shadow-md"
                        />
                    </motion.div>    
                    </div>
                </section>

                <motion.section
                    className="bg-[#BF5717] text-white py-20 text-center"
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeInUp}
                    viewport={{ once: true }}
                >
                    <h2 className="text-4xl font-serif font-bold mb-10">
                    Principles. Passion. Empowerment.
                    </h2>
                    <div className="flex flex-wrap justify-center gap-40">
                    <img src={Img1} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
                    <img src={Img2} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
                    <img src={Img3} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
                    <img src={Img4} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
                    </div>
                </motion.section>
            </div>
            <Footer />
        </>
    )
}